

import TiwiMixin from '../../mixins/TiwiMixin';
import ModalPopup from '../ModalPopup';
import _ from 'lodash';
// import axios from 'axios';


import RemoteApiService from '../../services/remote_api';


export default {
    mixins: [TiwiMixin],
    components: {
        ModalPopup
    },
    props: {
        bundles: {
            required: false,
            default: [],
            type: Array
        },
        onSubmit: {
            required: false,
            default: () => { },
            type: Function
        },
        roles: {
            required: false,
            default: {},
            type: Object
        },
    },
    data() {
        return {

            options: {},
            showModal: false,

            districts: [],
            cities: [],


            school_bundles: [],


            school_search_string: '',
            schools_found: [],

            current_bundle: null,

            // current_bundle.school: null, // selezionata nella posizione corrente
            // current_bundle.school_type: null, 
            // current_bundle.teaching_areas: [],


            current_state: 'main', // main, school-form, bundle-delete
            school_form: {
                id: null,
                name: '',
                address: '',
                district_code: '',
                city: '',
                postal_code: '',
                email: '',
                phone: '',
                head_teacher: '',
            },
            school_form_errors: {},


            show_teaching_areas: false,
        }
    },
    mounted: function () {
        this.getOptions();

        if( this.bundles && this.bundles.length ){
            // console.log( this.bundles );
            this.school_bundles = this.bundles;
            this.setCurrentBundle( this.bundles[0] );
        }
            

        if( this.school_bundles.length == 0 ){ //TODO: spostare dopo il caricamento dinamico delle scuole dell'utente
             this.newBundle();
        }

        
        //this.remote_api = new RemoteApiService( this.config.desk_api_url, this.user.meta.remote_token );
    },
    methods: {
        getOptions:  function(){
            var self = this;


            this.api.get('schools/getOptions' )
            .then( (response) => {
                if(response.data.options)
                    self.options = response.data.options;
                
            })
            .catch( (error) => { 
                self.toast.error( 'Errore nella richiesta' );
            })
        },
        getDistricts:  function(){
            var self = this;

            if( !this.config.desk_api_url )
                return;
            
            //console.log(this.config.desk_api_url + 'city/getDistricts');
            this.remote_api.client.get('city/getDistricts' )
            .then( (response) => {
                if(response.data.districts)
                    self.districts = response.data.districts;
                
            })
            .catch( (error) => { 
                self.toast.error( 'Errore nella richiesta' );
            })
        },
        getCities:  function(){
            var self = this;
            
            if( !this.config.desk_api_url )
                return;
            self.setLoading(true)
            this.remote_api.client.get('city/getByDistrict/' + this.school_form.district_code )
            .then( (response) => {
                if(response.data.cities)
                    self.cities = response.data.cities;
                
            })
            .catch( (error) => { 
                self.toast.error( 'Errore nella richiesta' );
            })
            .finally(() => self.setLoading(false))
        },
        newBundle: function(){
            var new_bundle = {
                school: null,
                school_type: [],
                teaching_areas: [],
                active: false,
                
            };

            this.school_bundles.push(new_bundle);
            this.setCurrentBundle(new_bundle);
            // this.school_form = new_bundle.school;
        },
        setCurrentBundle: function(bundle){
            for( var i in this.school_bundles ){
                this.school_bundles[i].active = false;
            }
            bundle.active = true;
            this.current_bundle = bundle;
            this.current_state = 'main';
            this.setSchoolSearchString();

        },

        searchSchool:  _.debounce( function(){
            var self = this;
            
            if(this.school_search_string.length < 3 )
                return;
            
            if( !this.config.desk_api_url )
                return;
            
            self.setLoading(true)
            this.remote_api.client.get('school/search/' + this.school_search_string)
            .then( (response) => {
                if(response.data.schools)
                    self.schools_found = response.data.schools;
                
            })
            .catch( (error) => { 
                self.toast.error( 'Errore nella richiesta' );
            })
            .finally(() => self.setLoading(false));
        }, 250),
        selectSchool: function( school ){
            for( var i in this.school_bundles){
                if( this.school_bundles[i].school && (school.id == this.school_bundles[i].school.id) ){
                    this.toast.error('Impossibile selezionare più volte la stessa scuola');
                    return;
                }
                    
            }

            this.current_bundle.school = school;
            this.setSchoolSearchString()
            
            this.schools_found = [];

        },
        deselectSchool: function(){
            this.current_bundle.school = null;
            this.school_search_string = ''; 
        },
        insertSchool: function(){
            this.getDistricts();
            this.current_state = 'school-form';
        },
        resetSchoolForm: function(){
            this.school_form = {
                id: null,
                name: '',
                address: '',
                district_code: '',
                city: '',
                postal_code: '',
                email: '',
                phone: '',
                head_teacher: '',
            };
        },
        setPostalCode: function(){
            // non abbiamo il dato dalla tabella delle città

        },

        saveSchool: function () {

            console.log('saveSchoolData');
            const self = this;

            const post_data = {
                user_id: this.user.meta.desk_id,
                school: {
                    id: this.school_form.id,
                    name: this.school_form.name,
                    address: this.school_form.address,
                
                    city: this.school_form.city?.city,
                    city_id: this.school_form.city?.id,
                    district_code: this.school_form.district_code,
                    postal_code: this.school_form.postal_code,
                    email: this.school_form.email,
                    phone: this.school_form.phone,
                    head_teacher: this.school_form.head_teacher,
                }
            }

            self.setLoading(true)
            this.remote_api.client.post('school/store', post_data)
                .then((response) => {
                    if (response.data.status) {
                        self.toast.success('Scuola salvata correttamente!');

                        if( response.data.school ){
                            self.current_bundle.school = response.data.school;
                            self.current_state = 'main';
                            self.resetSchoolForm();
                            self.setSchoolSearchString();
                        }


                        self.school_form_errors = {};
                        
                        // this.updateDeskUser(); // faccio la chiamata API per aggiornare su DESK i meta dell'utente 
                        // CHECK: commentato perche qui non ci serve aggiornare i dati utente
                    }
                    else {

                        self.school_form_errors = response.data.errors ? response.data.errors : {};
                        self.toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    self.toast.error('Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))
        },
        toggleModal: function () {
            if (this.showModal) {
                this.onClose(this.form);
            }

            this.showModal = !this.showModal;
        },

        setSchoolSearchString: function(){

            if(!this.current_bundle?.school) {
                this.school_search_string = '';
            }
            else    
                this.school_search_string = this.getBundleDescription(this.current_bundle);
            
            
        },
        getBundleDescription: function(bundle){
            if( !this.current_bundle.school ){
                return '';
            }
            else if( this.current_bundle?.school?.user_id){
                
                return this.current_bundle.school.name + ', ' + this.current_bundle.school.city; // + ' - (Utente)' 
            }
            else{
              
                return this.current_bundle.school?.name + ', ' + this.current_bundle.school?.city + ' - (' + this.current_bundle.school.code + ')'; 
            }
        },
        handleBundleDelete: function(){
            if(
                !this.current_bundle.school &&
                (!this.current_bundle.school_types || this.current_bundle.school_types.length == 0) &&
                (!this.current_bundle.teaching_areas || this.current_bundle.teaching_areas.length == 0)

            ){
                this.deleteCurrentBundle();
            }
            else
                this.current_state = 'bundle-delete'
        },
        deleteCurrentBundle: function(){
            var idx = this.school_bundles.indexOf( this.current_bundle );

            console.log( 'DELETE ' + idx );

            if( idx != -1) 
                this.school_bundles.splice(idx, 1);

            this.current_bundle = this.school_bundles[0];
            this.current_state = 'main';
        },
        saveBundles: function(){
            var self = this;

            this.setLoading(true);
            var post_data = {
                school_bundles: this.school_bundles,
            }

            this.api.post( '/users/update', post_data)
                .then((response) => {
                    if (response.data.success) {
                        self.toast.success('Salvataggio effettuato correttamente')

                        //self.syncSchools();
                        self.showModal = false;


                        // Ricarica la pagina dopo 1 secondo se tutto ok
                        
                        setTimeout(function() {
                             location.reload();
                        }, 1000);
                        
                    }
                    else {
                        self.toast.error(response.data.message);
                        
                    }
                })
                .catch((error) => {
                    console.log(error);
                    self.toast.error(error ? error : 'Errore nella richiesta');
                })
                .finally(() => self.setLoading(false))

        },

        /*
        syncSchools: function(){

            var self = this;

            var school_ids = this.school_bundles.map( function( item ){
                return item.school.id;
            });

            var post_data = {
                school_ids: school_ids,
            };


            self.setLoading(true)
            this.remote_api.client.post('school/syncUsers', post_data)
                .then((response) => {
                    if (response.data.status) {
                        //self.toast.success('Sincronizzazione remota eseguita correttamente');

                    }
                    
                })
                .catch((error) => {
                    //self.toast.warning('Errore nella sincronizzazione remota');
                    console.log('Errore nella sincronizzazione remota');
                })
                .finally(() => self.setLoading(false))


        },
        */
        onClose: function() {
            this.showModal = false;
        },
    },
    watch:{
        app_ready: function(newVal, oldVal){

             if(newVal){
                console.log('app_ready', this.config);
                this.remote_api = new RemoteApiService( this.config.desk_api_url, this.user.meta.remote_token, this.user.ID );
             }
        }
    }
    
}
